<template>
  <div class="acmper">
    <div>
      <button
        class="buto"
        @click="$router.back()"
      >返回</button>
      <van-search
        style="padding:0;display: inline-block;"
        v-model.trim="seachValue"
        placeholder="请输入孩子姓名"
      />
    </div>

    <div style="margin-top:25px">
      <van-row>
        <van-col
          span="2"
          class="text-center"
        >序号</van-col>
        <van-col
          span="4"
          class="text-center"
        >姓名</van-col>
        <van-col
          span="2"
          class="text-center"
        >性别</van-col>
        <van-col
          span="3"
          class="text-center"
        >房间</van-col>

        <van-col
          :span="6"
          class="text-center"
        >电话</van-col>
        <van-col
          :span="6"
          class="text-center"
        >渠道</van-col>
      </van-row>

      <div style="margin-top:5px">
        <div
          v-for="(item2,index2) in List"
          :key="index2"
          @click="skipPath(item2)"
        >
          <van-row
            type="flex"
            style="margin-top:5px"
          >
            <van-col
              span="2"
              class="text-center line-h20"
            >{{index2+1}}</van-col>
            <van-col
              span="4"
              class="text-center line-h20"
            >{{item2.real_name}}</van-col>
            <van-col
              span="2"
              class="text-center line-h20"
            >{{item2.sex=='man'?'男':'女'}}</van-col>
            <van-col
              span="3"
              class="text-center"
            >
              {{item2.room}}
            </van-col>

            <van-col
              :span="6"
              class="text-center line-h20"
              style="color:#ee0a24;"
            >{{item2.mobile_no}}</van-col>
            <van-col
              :span="6"
              class="text-center"
            >{{item2.business_name}}</van-col>
          </van-row>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { debounce } from '@/common/util.js'
export default {
  data() {
    return {
      seachValue: '',
      project_id: '',
      List: [],
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.$watch(
      'seachValue',
      this.$mUtil.debounce((newQuery) => {
        this.$axios
          .post('/project/participantsearch', {
            project_id: this.project_id,
            keyword: newQuery,
          })
          .then((res) => {
            this.List = res.data.data
          })
      }, 1000)
    )
  },
  methods: {
    skipPath(item) {
      console.log(item)

      if (!item.team_id) {
        this.$toast('该孩子暂未分配小队')
        return
      }
      this.$router.push({
        path: '/camper',
        query: {
          team3_id: item.team_id,
          project_id: this.project_id,
          seachPath: 'posSeach',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.acmper {
  padding: 30px 20px;
  height: 100%;
}
.buto {
  vertical-align: top;
  background-color: #ee0a24;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}
.text-center {
  text-align: center;
  font-weight: 700;
  padding: 5px 0;
}
</style>